export default __webpack_public_path__ + "static/media/youtube-boxed-icon copy.fe869ce4.svg";